if (!customElements.get('st-colorways')) {
  customElements.define('st-colorways', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const update = (event) => {
        const link = event.target.closest('a[data-variants]');
        if (!link || !this.contains(link)) return;
        try {
          const currentId = new URL(location.href).searchParams.get('variant');
          const source = JSON.parse(this.querySelector('[data-source-variants]').textContent);
          const selected = source.find((variant) => variant.id === currentId);
          if (!selected) return;
          const target = JSON.parse(link.dataset.variants).find((variant) => variant.size === selected.size);
          if (!target) return;
          const url = new URL(link.href);
          url.searchParams.set('variant', target.id);
          link.href = url.pathname + url.search;
        } catch { /* Keep the server-rendered link if a product has incomplete data. */ }
      };
      for (const type of ['pointerover', 'focusin', 'click']) {
        this.addEventListener(type, update, { signal: this.controller.signal });
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
